export default "__VITE_ASSET__CLNtaXvH__"